import { useAccount } from "wagmi"
import { MARKETPLACE_CHAIN_ID } from "../marketplace-chain-id"
import type { ProductType } from "@repo/loomlock/model-types"
import { useProductsBalance } from "@/shared/indexer/use-indexer-products"

export function useOwnsNFT({
  tokenId,
  productType,
}: {
  // the marketplace listing iterates on products, so the nft might not
  tokenId: string
  productType: ProductType
}) {
  const { address } = useAccount()
  const { isPending, getBalance } = useProductsBalance({
    address: address,
    productType: productType,
    chainIds: [MARKETPLACE_CHAIN_ID],
  })

  const isOwner =
    productType &&
    tokenId &&
    (getBalance(productType, tokenId)?.balance || 0) > 0

  return {
    isOwner,
    isPending,
  }
}
